
import objectPath from 'object-path'
import initialStateCancelInsurance from './initialState'

const mutations = {
  clearCancelInsuranceState(state) {
    state.cancelInsurances = []
  },
  setCancelInsuranceInitial(state) {
    state.cancelInsurances.push(initialStateCancelInsurance())
  },
  setCancelInsurancesPenalties(state, { target, penalties }) {
    objectPath.set(state, `${target}.penalties`, {
      ...objectPath.get(state, `${target}.penalties`),
      isLoading: false,
      collection: penalties
    })
  }
}

export default mutations